export default "__VITE_ASSET__DizdkHh1__"